import React, { useEffect, useState } from "react";
import "../../../../assets/scss/components/clientarea/serviceRequest/serviceRequest.scss";
import { config } from "../../../../config/domain";
import EdButton from "../../../generic/edButton";
import RadioButton from "../../../generic/radioButton";
import { smtfOptions, smtfMsg } from "./constant";
import {
  smtfValidation,
  createSMTFSR,
  getServicingDetails,
} from "../../../service/serviceRequest/srApiService";
import LoginService from "../../../service/login/loginService";
import { OtpSection } from "../../generic/otpSection";

interface ISuccessValidation {
  AccountCode: string;
  AccountName: string;
  PAN: string;
  MobileNumber: string;
  EmailID: string;
  IsSMTF: string;
  ExistingOption: string;
  TradingStatus: string;
  ValidationStatus: string;
  ValidationRemarks: string;
}

interface IRequestObj {
  acTyp: string;
  dpId: string;
  reqSubStatus: string;
  assignedTeamCode: number;
  assignedTeamName: string;
  callTypId: number;
  subTypId: number;
  stmfPref: number;
  editId: number;
}

export const Smtf = (props: any) => {
  const [enableSMTF, setEnableSMTF] = useState<boolean>(false);
  const [otpSection, setOtpSection] = useState<boolean>(false);
  const [enableBtnSubmit, setEnableBtnSubmit] = useState<boolean>(false);
  const [impersonateUser, setImporsonateUser] = useState<boolean>(false);
  const [invalidTime, setInvalidTime] = useState<boolean>(false);
  const [selectedSMTFOption, setSelectedSMTFOption] = useState<string>("");
  const [invalidTimeMsg, setInvalidTimeMsg] = useState<any>("");
  const [enableOtpSection, setEnableOtpSection] = useState<boolean>(false);
  const [existingOption, setExistingOption] = useState<string>("");
  const [rmName, setRMName] = React.useState<any>({ name: "", mailId: "" });

  const [smtfValidationRes, setSMTFValidationRes] =
    useState<ISuccessValidation>({
      AccountCode: "",
      AccountName: "",
      PAN: "",
      MobileNumber: "",
      EmailID: "",
      IsSMTF: "",
      ExistingOption: "",
      TradingStatus: "",
      ValidationStatus: "",
      ValidationRemarks: "",
    });

  useEffect(() => {
    getRMName();
    validation();
  }, []);

  async function getRMName() {
    props.setParLoader(true);
    try {
      let details = await getServicingDetails();
      props.setParLoader(false);
      if (details) {
        setRMName({
          name: details.tradingDealerNameField, 
          mailId: details.tradingDealerEmailField
        });
      }
    } catch (error) {
      props.setParLoader(false);
    }
  }
  
  const smtfOptionsList = smtfOptions.map((item, index) => {
    return (
      <li key={index} className="comp_txt">
        <RadioButton
          list={{
            value: item.value,
            display: item.heading,
          }}
          name="smtf"
          selected={selectedSMTFOption}
          onChange={(e) => {
            onChange(e);
          }}
        />
        <p className="item-desc">{item.description}</p>
      </li>
    );
  });

  /**
   *  SMTF Validation
   */
  const validation = async () => {
    props.setParLoader(true);
    try {
      const valResponse = await smtfValidation();
      props.setParLoader(false);
      if (
        valResponse &&
        valResponse.hasOwnProperty("data") &&
        valResponse.data.hasOwnProperty("value")
      ) {
        const value = JSON.parse(valResponse.data.value);
        if (value && Array.isArray(value.result) && value.result.length > 0) {
          let result = value.result[0];
          setSMTFValidationRes(result);
          if (result.IsSMTF === "N") {
            setEnableSMTF(false);
            setEnableBtnSubmit(false);
          } else {
            setSelectedSMTFOption(result.ExistingOption);
            setEnableSMTF(true);
            setExistingOption(result.ExistingOption);
            // setEnableBtnSubmit(true);
          }
        } else {
          props.setParLoader(false);
          openSMTFErrorPopup();
        }
      } else {
        if (
          valResponse &&
          valResponse.error &&
          valResponse.error.errCd === "SR0031"
        ) {
          setInvalidTime(true);
          setInvalidTimeMsg(valResponse.error.errMsg);
        }
        props.setParLoader(false);
      }
    } catch (error) {
      props.setParLoader(false);
      openSMTFErrorPopup();
    }
  };

  /**
   * Check User Impersonated
   */
  const isImpersonated = () => {
    return window.localStorage.getItem("isImpersonated");
  };

  /**
   * On SMTF Options selections
   */
  const onChange = (event: any) => {
    setSelectedSMTFOption(event.target.value);
    if (isImpersonated()) {
      setOtpSection(true);
      setImporsonateUser(true);
    } else {
      if(event.target.value == existingOption)
        setEnableBtnSubmit(false);
      else setEnableBtnSubmit(true);
    }
  };

  /**
   * Error Message for SMTF
   */
  const openSMTFErrorPopup = () => {
    props.setLoader(false);
    props.onSubmit("smtf", {
      headerText: smtfMsg.error,
    });
  };

  /**
   * Successful Message for SMTF
   */
  const openSRSuccessPopup = () => {
    props.setLoader(false);
    let paramObj: any = {
      headerText: smtfMsg.createSR.headerText,
      content: smtfMsg.createSR.content,
      popupType: "Success"
    };
    props.onSubmit("smtf", paramObj);
  };

  /**
 * Error Popup For Already SR Created
 */
  const openExistSrPopup = () => {
  props.setLoader(false);
  props.onSubmit("smtf", {
    headerText: "You have an active service request",
    content:
      "You have already raised this request for the day.",
  });
};
  /**
   * Submit SMTF
   */
  const submitDetails = async () => {
    setEnableBtnSubmit(false);
    try {
      props.setParLoader(true);
      let reqObj: IRequestObj = {
        acTyp: LoginService.getAccData("accTyp"),
        dpId: "none",
        reqSubStatus: "Approved",
        assignedTeamCode: 4,
        assignedTeamName: "Ops Helpdesk team",
        callTypId: 18,
        subTypId: 651,
        stmfPref: Number(selectedSMTFOption),
        editId: 0,
      };

      const response = await createSMTFSR(reqObj);
      if (
        response &&
        response.hasOwnProperty("data") &&
        response.data.hasOwnProperty("srId")
      ) {
        props.setParLoader(false);
        const value = JSON.parse(response.data.srId);
        if (value) {
          openSRSuccessPopup();
        } else {
          props.setParLoader(false);
          openSMTFErrorPopup();
        }
      } else if (
        Object.keys(response).length > 0 &&
        response.hasOwnProperty("error") &&
        response.error.errCd === "SR0005"
      ) {
        openExistSrPopup();
      } else {
        if (response && response.error) {
          props.setParLoader(false);
          openSMTFErrorPopup();
        }
      }
      setEnableBtnSubmit(true);
    } catch (error) {
      props.setParLoader(false);
      openSMTFErrorPopup();
      setEnableBtnSubmit(true);
    }
  };

  const showOtpSection = () => {
    setEnableOtpSection(true);
  };

  return (
    <>
      {!props.loader && (
        <div className="smtf">
          {invalidTime ? (
            <p className="help-text red">
              <span>{invalidTimeMsg}</span>
            </p>
          ) : (
            <>
              {enableSMTF ? (
                <>
                  <div className="smtf-list-container">
                    <ul>{smtfOptionsList}</ul>
                  </div>
                  <div className="smtf-otp-section">
                    {impersonateUser && selectedSMTFOption ? (
                      <div className="form-field custom-col noLeftPAdding space-mb-0">
                        {otpSection ? (
                          <>
                            {!enableOtpSection ? (
                              <button
                                type="submit"
                                className="btn btn-olink login-btn"
                                title="Request OTP"
                                onClick={showOtpSection}
                              >
                                Request OTP
                              </button>
                            ) : (
                              <>
                                {" "}
                                <OtpSection
                                  details={{
                                    acTyp: LoginService.getAccData("accTyp"),
                                    reqTyp: "generate",
                                    sr: "Normal to SMTF Fund Movement Preference",
                                    srType:
                                      "Normal to SMTF Fund Movement Preference",
                                    srAcType: "Trading",
                                    type: "mobile_and_email",
                                    mobileNo: smtfValidationRes.MobileNumber,
                                    emailId: smtfValidationRes.EmailID,
                                  }}
                                  otpVerified={(token: any) => {
                                    setOtpSection(false);
                                    setEnableBtnSubmit(true);
                                  }}
                                  setLoader={(val: boolean) => {
                                    props.setParLoader(val);
                                  }}
                                />
                              </>
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div className="smtf-validation text-center">
                    <p>
                      {smtfValidationRes.ValidationRemarks.replace(",", "")} for
                      your account.
                    </p>
                    <p>Please get in touch with your RM.</p>
                  </div>
                  <div>
                    <p className="field-head text-center">{rmName.name}</p>
                    <p className="text-center">
                      <a
                        href={`mailto:${rmName.mailId}`}
                        className="mail_link"
                      >
                        {rmName.mailId}
                      </a>
                    </p>
                  </div>
                </>
              )}
            </>
          )}
          <div className="modal-footer common-modal--footer">
            <div className="mob-center">
              <EdButton
                className="btn-padding common_button login-btn block_btn"
                value="Submit"
                btnTyp="primary"
                disabled={!enableBtnSubmit}
                onClick={(e: any) => {
                  submitDetails();
                  e.preventDefault();
                }}
              />
              <button
                type="submit"
                className="btn btn-olink login-btn"
                title="Cancel"
              >
                <a
                  className="btn btn-olink login-btn"
                  href={config.rootUrl + "/clientarea/servicerequest"}
                >
                  Cancel
                </a>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
